import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideTopBannerPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import TopBannerPopupContent from "./TopBannerPopupContent"

// Components
import Popup from "@modules/popup/Popup"

const TopBannerPopup = () => {
    const { infoBanner } = useSelector((state: RootState) => state.settings)
    const dispatch = useDispatch<any>()
    const isOpen = useSelector((state: RootState) => state.app.topBannerPopup.visible)

    const dialogContent = infoBanner?.banner?.dialogContent

    return (
        <Popup
            onClose={() => dispatch(hideTopBannerPopup())}
            isOpen={isOpen}
            hideCloseButton={true}
            isHeaderActionsOverflow={dialogContent?.image ? true : false}
            className="top-banner-popup"
        >
            {dialogContent ? <TopBannerPopupContent {...infoBanner} /> : null}
        </Popup>
    )
}

export default TopBannerPopup
